import { api } from './client';

export interface UploadedMedia {
  mediaUrl: string;
  mediaType: 'image' | 'video' | 'audio' | 'document';
  mimeType: string;
  fileName: string;
  size: number;
}

/**
 * Upload a file to the backend and get back a servable media URL that can be
 * attached to a chat or team message. Mirrors the multipart pattern used by
 * voiceService.uploadCallRecording — let the browser set the multipart boundary
 * by overriding the JSON default with Content-Type: undefined.
 */
export async function uploadFile(file: File): Promise<UploadedMedia> {
  const form = new FormData();
  form.append('file', file, file.name);
  return api.post<UploadedMedia>('/uploads', form, {
    headers: { 'Content-Type': undefined },
  });
}
